<template>
  <div class="atoms-select__position-relative">
    <CSelect
      v-model="select"
      v-bind="{
        fontSize: '14px',
        lineHeight: '19px',
        color: 'var(--colors-light-primary-gray1)',
        borderColor: 'var(--colors-light-secondary-divider)',
        variant,
        _focus: {
          borderColor: 'var(--colors-light-secondary-divider'
        },
        ...styleByVariant,
        ...$attrs
      }"
      class="atoms-select"
      @change="onChange"
    >
      <option v-if="placeholder" value=""
:disabled="disabledPlaceholder">
        {{ placeholder }}
      </option>
      <slot />
      <template v-if="options">
        <option v-for="option in options" :key="keyProp ? option[keyProp] : option.value"
:value="option.value">
          {{ option.label }}
        </option>
      </template>
    </CSelect>
    <div
      v-if="isLoading"
      class="atoms-select__loader"
      :style="'background: url(' + base_url + 'images/loading.svg' + ') no-repeat center center;'"
    />
  </div>
</template>

<script>
import { CSelect } from "@chakra-ui/vue";
import _ from "lodash";

/**
 * Select component based on https://vue.chakra-ui.com/select
 * @prop {String} initialValue
 * @prop {String} variant currently options : "unstyled" | "outline" | "filled" | "flushed"
 */
export default {
  components: {
    CSelect
  },
  props: {
    initialValue: String,
    isLoading: Boolean,
    placeholder: {
      type: String,
      default: "",
      required: false
    },
    options: Array,
    variant: {
      type: String,
      validator: value => {
        const options = ["outline", "unstyled", "flushed", "filled"];
        const validOption = !!options.includes(value);
        if (!validOption) console.error(`Allowed select variant options : ${options.join(" - ")}`);
        return validOption;
      },
      default: "flushed"
    },
    keyProp: {
      type: String,
      default: "value"
    }
  },
  data() {
    return {
      disabledPlaceholder: false,
      select: "",
      base_url: process.env.VUE_APP_BASE_URL
    };
  },
  methods: {
    onChange: _.debounce(function (val) {
      this.$emit("change", val);
    }, 0)
  },
  computed: {
    styleByVariant() {
      const VARIANTS = {
        outline: {
          borderRadius: "32px"
        }
      };

      return VARIANTS[this.variant] || {};
    }
  },
  watch: {
    initialValue: {
      handler(newInitialValue) {
        this.$nextTick(() => {
          this.select = newInitialValue;
          this.disabledPlaceholder = this.select !== null && this.select !== "";
        });
      },
      immediate: true
    }
  }
};
</script>

<style>
.atoms-select select[data-chakra-component="CSelectInput"] {
  font-weight: 700;
}

.atoms-select div[data-chakra-component="CSelectIconWrapper"] {
  right: 0rem !important;
}

.atoms-select select[disabled] {
  cursor: not-allowed;
  opacity: 0.6;
}

.atoms-select__position-relative {
  position: relative;
}

.atoms-select__loader {
  position: absolute;
  right: 25px;
  top: 8px;
  background-size: 45px 45px !important;
  width: 25px;
  height: 25px;
}
</style>
